import { useMemo } from 'react'

export const suggestibleAttributes = [
  'size',
  'size_uom',
  'size_value',
  'unit_count',
  'unit_value',
  'unit_uom',
  'bottle',
  'brand_name',
  'name',
  'description',
  'details',
  'product_category_id',
]

export const useIsSuggestibleAttribute = (attributeName: string) =>
  useMemo(() => isSuggestibleAttribute(attributeName), [attributeName])

export const isSuggestibleAttribute = (attributeName: string) => {
  if (!attributeName) return false
  return suggestibleAttributes.includes(attributeName)
}
